import service from './team-history-full-service';

export default {
  namespaced: true,

  state: {
    loading: false,
    list: [],
    last: true
  },

  getters: {
    loading: (state) => state.loading,
    list: (state) => state.list,
    last: (state) => state.last
  },

  mutations: {
    LOADING(state, payload) {
      state.loading = !!payload;
    },

    LIST(state, payload) {
      state.list = payload || [];
    },

    LAST(state, payload) {
      state.last = !!payload;
    },

    CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.last = true;
    }
  },

  actions: {
    setup({ commit, dispatch }) {
      commit('CLEAR');
      return dispatch('fetch');
    },

    fetch({ commit, getters }) {
      commit('LOADING', true);

      const lastmodified =
        getters.list && getters.list.length
          ? getters.list[getters.list.length - 1].modified
          : 10000000000000;

      return service
        .fetch(lastmodified)
        .then((response) => {
          commit('LAST', response.last);
          commit(
            'LIST',
            getters.list.concat(response.data)
          );
          commit('LOADING', false);
        });
    },

    clear({ commit }) {
      commit('CLEAR');
    }
  }
};



// WEBPACK FOOTER //
// ./src/entities/team/team-history/team-history-full/team-history-full-store.js